import React from "react";
import version from "../../package.json";
import { useSettings } from "shared/hooks/use-settings";

const Footer = () => {
    const { settings } = useSettings();
    var beVersion = "";

    if (settings && settings.globalSettings) {
        beVersion = settings.globalSettings.releaseVersion;
    }

    return (
        <footer id="footer">
            <div className="container">
                <img
                    src="/images/syn_tag_full_rev_color_rgb.png"
                    alt="Syndigo"
                    className="logo"
                />
                {beVersion && (
                    <label style={{ color: "#ffffff" }}>
                        v{`${beVersion}`} - v{`${version.version}`}{" "}
                    </label>
                )}
            </div>
        </footer>
    );
};

export default Footer;
